export default "__VITE_PUBLIC_ASSET__6e8058b2__"